<script>
import { mapState } from 'vuex';

export default {
  name: 'ItineraryEditPosterInfo',
  props: {
    itineraryPoster: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState({
      poster: state => state.itinerary.poster.item,
      loading: state => state.itinerary.poster.loading,
      error: state => state.itinerary.poster.error,
    }),
    showGenerateQrCodeButton() {
      if (!this.poster.info.cta.qrCode) {
        return true;
      }
      return this.poster.info.cta.link !== this.itineraryPoster.info.cta.link;
    },
  },
  methods: {
    save() {
      this.$emit('save', this.itineraryPoster);
    },
    generateQrCode(link) {
      this.$emit('generate-qr-code', link);
    },
  },
};
</script>
<template>
  <v-card class="poster-info-card">
    <v-card-title class="pb-0">
      <div class="headline">Price info / booking</div>
    </v-card-title>
    <v-card-text class="d-flex flex-col gap-6 pt-4">
      <div v-if="itineraryPoster.info.booking" class="price-section">
        <div class="text-subtitle-2 mb-2">Booking Price</div>
        <div class="d-flex gap-4">
          <v-text-field
            v-model="itineraryPoster.info.booking.prefix"
            :loading="loading"
            label="Prefix"
            variant="outlined"
            density="comfortable"
            hide-details
            class="price-field"
          />

          <v-text-field
            v-model="itineraryPoster.info.booking.price"
            :loading="loading"
            label="Price"
            variant="outlined"
            density="comfortable"
            hide-details
            class="price-field"
          />

          <v-text-field
            v-model="itineraryPoster.info.booking.suffix"
            :loading="loading"
            label="Suffix"
            variant="outlined"
            density="comfortable"
            hide-details
            class="price-field"
          />
        </div>
      </div>

      <div v-if="itineraryPoster.info.extra" class="price-section">
        <div class="text-subtitle-2 mb-2">Extra Price</div>
        <div class="d-flex gap-4">
          <v-text-field
            v-model="itineraryPoster.info.extra.prefix"
            :loading="loading"
            label="Prefix"
            variant="outlined"
            density="comfortable"
            hide-details
            class="price-field"
          />

          <v-text-field
            v-model="itineraryPoster.info.extra.price"
            :loading="loading"
            label="Price"
            variant="outlined"
            density="comfortable"
            hide-details
            class="price-field"
          />

          <v-text-field
            v-model="itineraryPoster.info.extra.suffix"
            :loading="loading"
            label="Suffix"
            variant="outlined"
            density="comfortable"
            hide-details
            class="price-field"
          />
        </div>
      </div>

      <div v-if="itineraryPoster.info.cta" class="cta-section">
        <div class="text-subtitle-2 mb-2">Call to Action</div>
        <div class="d-flex gap-6">
          <div class="d-flex flex-col gap-4 w-85">
            <v-text-field
              v-model="itineraryPoster.info.cta.title"
              :loading="loading"
              label="Title"
              variant="outlined"
              density="comfortable"
              hide-details
            />

            <v-text-field
              v-model="itineraryPoster.info.cta.text"
              :loading="loading"
              label="Text"
              variant="outlined"
              density="comfortable"
              hide-details
            />

            <v-text-field
              v-model="itineraryPoster.info.cta.link"
              :loading="loading"
              label="Link"
              variant="outlined"
              density="comfortable"
              hide-details
            />
          </div>

          <div class="w-15 d-flex flex-col justify-center align-center">
            <div class="qr-container">
              <v-img
                v-if="itineraryPoster.info.cta.qrCode"
                :src="itineraryPoster.info.cta.qrCode.original"
                class="qr-image"
              />
            </div>
            <v-btn
              v-if="showGenerateQrCodeButton"
              color="primary"
              variant="tonal"
              class="mt-4"
              @click="generateQrCode(itineraryPoster.info.cta.link)"
            >
              Generate QR code
            </v-btn>
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<style scoped lang="scss">
.poster-info-card {
  border-radius: 12px;
}

.price-section, .cta-section {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  padding: 16px;
}

.w-85 {
  width: 85%;
}

.w-15 {
  width: 15%;
}

.price-field {
  flex: 1;
}

.qr-container {
  width: 100%;
  aspect-ratio: 1;
  background: white;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.qr-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.gap-4 {
  gap: 1rem;
}

.gap-6 {
  gap: 1.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/itinerary/ItineraryEditPosterInfo.vue